(function () {
  function getBar() { return document.querySelector('.sticky-atc'); }

  function getButton(bar) {
    var form = bar && document.getElementById(bar.getAttribute('data-form'));
    if (!form) { form = document.querySelector('form[action*="/cart/add"]'); }
    var btn = null;
    if (form) {
      btn = form.querySelector('[data-add-to-cart]') || form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]');
    }
    if (!btn) {
      btn = document.querySelector('[data-add-to-cart]') || document.querySelector('form[action*="/cart/add"] button[name="add"]');
    }
    return btn;
  }

  // The PDP price and its RRP strike-through. The compare element is written by
  // the Assortion tier widget (see snippets/rm-vd-default.liquid); it is left
  // EMPTY when the product is not discounted, which is the signal to hide the
  // sticky strike-through rather than show a duplicate of the sale price.
  function getPriceEls(bar) {
    var sec = document.getElementById(bar.getAttribute('data-section'));
    return {
      price: (sec && sec.querySelector('[data-product-price]')) || document.querySelector('[data-product-price]'),
      compare: (sec && sec.querySelector('[data-compare-price]')) || document.querySelector('[data-compare-price]')
    };
  }

  // In theme-preview mode Shopify docks a toolbar at the bottom that covers the bar.
  // Lift the bar above it when present; stays flush (0) on the live site.
  function applyPreviewOffset(bar) {
    var pbar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
    var want = pbar ? '54px' : '0px';
    if (bar.style.bottom !== want) { bar.style.bottom = want; }
  }

  function sync() {
    var bar = getBar(); if (!bar) return;
    applyPreviewOffset(bar);
    var btn = getButton(bar); if (!btn) return;
    var sBtn = bar.querySelector('[data-sticky-add]');
    if (sBtn && !sBtn.getAttribute('data-wired')) {
      sBtn.setAttribute('data-wired', '1');
      sBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var b = getButton(getBar());
        if (b) { b.click(); }
      });
    }

    var els = getPriceEls(bar);
    var sPrice = bar.querySelector('[data-sticky-price]');
    if (els.price && sPrice) { var t = els.price.textContent.trim(); if (t && sPrice.textContent !== t) { sPrice.textContent = t; } }

    // RRP strike-through. Hidden unless there is a compare value that actually
    // differs from what we are charging - so full-price products stay clean and
    // a stale/duplicated value never renders as a fake discount.
    var sCmp = bar.querySelector('[data-sticky-compare]');
    if (sCmp) {
      var cmp = els.compare ? els.compare.textContent.trim() : '';
      var now = sPrice ? sPrice.textContent.trim() : '';
      if (cmp && cmp !== now) {
        if (sCmp.textContent !== cmp) { sCmp.textContent = cmp; }
        if (sCmp.hidden) { sCmp.hidden = false; }
      } else if (!sCmp.hidden) {
        sCmp.hidden = true;
      }
    }

    var sText = bar.querySelector('[data-sticky-add-text]');
    var tt = btn.querySelector('[data-add-to-cart-text]');
    if (tt && sText) { var v = tt.textContent.trim(); if (v && sText.textContent !== v) { sText.textContent = v; } }
    if (sBtn) { var d = btn.hasAttribute('disabled'); if (sBtn.disabled !== d) { sBtn.disabled = d; } sBtn.classList.toggle('is-disabled', d); }
  }

  var ticking = false;
  function update() {
    ticking = false;
    var bar = getBar(); if (!bar) return;
    var btn = getButton(bar);
    if (!btn) { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); return; }
    var r = btn.getBoundingClientRect();
    var show = r.bottom < 10;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  function onScroll() {
    if (!ticking) { ticking = true; (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(update); }
  }
  function boot() { sync(); update(); watch(); }

  // Event-driven re-sync (replaces the old 1.2s polling loop).
  var bootTimer = null;
  function scheduleBoot() { clearTimeout(bootTimer); bootTimer = setTimeout(boot, 150); }

  // Watch the real add-to-cart button (disabled state + PRE ORDER text via
  // [data-add-to-cart-text]) and both price elements for changes after variant
  // or tier switches - the tier widget rewrites price and RRP independently.
  var observer = window.MutationObserver ? new MutationObserver(scheduleBoot) : null;
  var watchedBtn = null;
  var watchedPrice = null;
  var watchedCompare = null;
  function watch() {
    if (!observer) return;
    var bar = getBar(); if (!bar) return;
    var btn = getButton(bar);
    var els = getPriceEls(bar);
    if (btn === watchedBtn && els.price === watchedPrice && els.compare === watchedCompare) return;
    observer.disconnect();
    watchedBtn = btn;
    watchedPrice = els.price;
    watchedCompare = els.compare;
    var opts = { childList: true, subtree: true, characterData: true };
    if (btn) { observer.observe(btn, { attributes: true, childList: true, subtree: true, characterData: true }); }
    if (els.price) { observer.observe(els.price, opts); }
    if (els.compare) { observer.observe(els.compare, opts); }
  }

  // Variant pickers fire change events inside the product form.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('form[action*="/cart/add"], [data-product-form], .product-single__meta')) { scheduleBoot(); }
  }, true);
  document.addEventListener('cart:updated', scheduleBoot);

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', boot);
  window.addEventListener('pageshow', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('DOMContentLoaded', boot);
  setInterval(boot, 10000); // slow safety net (was 1.2s)
  boot();
})();
